export class tbl_WbidFiles {
  id?: number;
  fileName?: string;
  fileContent?: string |Blob;

  constructor(id: number, fileName: string, fileContent: string) {
    this.id = id;
    this.fileName = fileName;
    this.fileContent = fileContent;
  }
}
